module.exports = __webpack_public_path__ + "static/media/user_avatar.fc6cc08b.png";